export default __webpack_public_path__ + "static/media/fio-logo.5d3c719e.svg";